<template>
  <span
    :class="classes"
    class="Icon"
  >
    <slot />
  </span>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'default',
  },
  size: {
    type: String,
    default: '',
  },
});

// Computed
const classes = computed(() => [
  props.type.length ? `Icon--${props.type}` : undefined,
  props.size.length ? `Icon--${props.size}` : undefined,
]);
</script>

<style scoped>
@reference "assets/css/tailwind.css";

.Icon {
  width: 40px;
  height: 40px;

  min-width: 40px;
  min-height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  svg {
    width: 16px;
    height: auto;
    display: block;
  }

  &.Icon--mini {
    width: 22px;
    height: 22px;

    min-width: 22px;
    min-height: 22px;

    svg {
      height: 14px;
      width: 14px;
    }
  }

  &.Icon--small {
    width: 32px;
    height: 32px;

    min-width: 32px;
    min-height: 32px;
  }

  &.Icon--large {
    width: 48px;
    height: 48px;

    min-width: 48px;
    min-height: 48px;
  }

  &.Icon--default {
    @apply bg-light text-text-light;
  }

  &.Icon--danger {
    @apply bg-danger-500 text-white;
  }

  &.Icon--success {
    @apply bg-success text-white;
  }
}
</style>
